import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/wsp-cast-sender/wsp-cast-sender/node_modules/next/dist/client/app-dir/link.js");
